<template>
  <div
    :am-mode="isActive ? 'edit' : 'show'"
    am-field-item
    @click="editMode()"
    v-click-outside="showMode"
    ref="field"
    @keyup.esc="showMode"
    tabindex="1"
  >
    <div am-show v-if="!isActive">{{ data.data }}</div>
    <textarea
      v-else
      ref="textarea"
      am-edit
      :style="`height:${heightArea}px; ${isOpenTop ? 'bottom: -4px; top: auto;' : null}`"
      v-model="value" />
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'FieldItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    heightArea: false,
    isActive: false,
    isOpenTop: false
  }),
  computed: {
    value: {
      get () {
        return this.data.data
      },
      set (value) {
        this.inputHeight()
        this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data = value
        this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
      }
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS']),
    showMode () {
      this.isOpenTop = false
      this.isActive = false
    },
    editMode () {
      this.isActive = true
      this.$emit('editing', this.data.index)
      setTimeout(() => {
        this.inputHeight()
      }, 0)
      if (this.$refs.field.getBoundingClientRect().y / window.innerHeight * 100 > 50) {
        this.isOpenTop = true
      }
    },
    inputHeight () {
      if (this.$refs.textarea.scrollHeight > this.$refs.textarea.clientHeight) {
        this.heightArea = this.$refs.textarea.scrollHeight
      }
    }
  }
}
</script>

<style lang="scss">
[am-field-item] {
  [am-show] {
    display: -webkit-box;
    -webkit-line-clamp: 6;
    -webkit-box-orient: vertical;
  }
  textarea:focus-visible {
    outline: none;
  }
}
</style>
